const logger = {
  error(error) {
    const isServerError = error.response;

    if (!isServerError) {
      window.console.error(error);
    }
  },

  warn(description, extraDetails) {
    window.console.warn(description);

    if (extraDetails) {
      console.log(extraDetails);
    }
  }
};

export default logger;
